import Dexie, { type Table } from "dexie";

// Offline cache.
//   tickets    , full ticket detail incl. QR payload (per ticket)
//   ticketLists, the user's ticket-list snapshot, keyed "all"
//
// Used by api.ts: writes happen on every successful fetch; reads
// happen as a fallback when fetch throws. At the door without signal,
// the QR still renders + the tickets list still loads.
export type CachedTicket = {
  id: string;
  qrPayload: string;
  // Cached so the QR-unlock time is known offline (festival tickets unlock at
  // the start of the event day). null/undefined = available immediately.
  qrUnlockAt?: string | null;
  data: unknown;
  cachedAt: number;
};

export type CachedTicketList = {
  key: string;
  data: unknown;
  cachedAt: number;
};

class AssemblyDB extends Dexie {
  tickets!: Table<CachedTicket, string>;
  ticketLists!: Table<CachedTicketList, string>;

  constructor() {
    super("assembly-cache");
    this.version(1).stores({
      tickets: "id, cachedAt",
    });
    this.version(2).stores({
      tickets: "id, cachedAt",
      ticketLists: "key, cachedAt",
    });
  }
}

export const db = new AssemblyDB();
